import type {
  MediaDetailNavigation,
  MediaDetailStep,
} from "src/components/media-detail/use-media-detail-controls";

type Args<T> = {
  items: readonly T[];
  currentId: string | null | undefined;
  getId: (item: T) => string;
  onSelect: (item: T) => void;
};

/**
 * Prev/next over the list a detail view was opened from. Stops at either end,
 * and offers no navigation when the current item isn't in the list (opened
 * from somewhere else, or filtered out since).
 */
export function getListNavigation<T>({
  items,
  currentId,
  getId,
  onSelect,
}: Args<T>): MediaDetailNavigation {
  if (currentId == null) return { kind: "none" };
  const index = items.findIndex((item) => getId(item) === currentId);
  if (index < 0 || items.length < 2) return { kind: "none" };

  const stepTo = (item: T | undefined): MediaDetailStep =>
    item === undefined
      ? { kind: "end" }
      : { kind: "neighbour", go: () => onSelect(item) };
  return {
    kind: "list",
    previous: stepTo(items[index - 1]),
    next: stepTo(items[index + 1]),
  };
}
